import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@adsk/bim360-matrix-react-icon-button';
import SvgIcon from '@adsk/bim360-matrix-react-svg-icon';
import Text from '@adsk/bim360-matrix-react-text';
import cancelInputRound from '@adsk/bim360-matrix-react-assets/cancel-input-round.svg';
import LinkToDocumentContainer from './LinkToDocumentContainer';
import LinkToDocumentPlaceholder from './LinkToDocumentPlaceholder';

const LinkToDocumentField = ({container, document, onRemoveDocument, onSelectDocumentPushpin, status}) => (
  <LinkToDocumentContainer container={container} onSelectDocumentPushpin={onSelectDocumentPushpin} status={status}>
    {startDocumentSelection => (
      <div className="LinkToDocumentField">
        {document ? (
          <div className="LinkToDocumentField__document">
            {/* Hiding tooltip as Text tooltip in modal is problematic in IE - https://git.autodesk.com/BIM360/bim360-matrix-react-components/issues/397 */}
            <Text className="LinkToDocumentField__document-name" ellipsis hideTooltip>
              {document.name}
            </Text>
            <IconButton
              className="LinkToDocumentField__document-remove-btn"
              onClick={() => onRemoveDocument(document)}
              styleType={IconButton.StyleType.MINIMAL}
            >
              <SvgIcon>{cancelInputRound}</SvgIcon>
            </IconButton>
          </div>
        ) : (
          <LinkToDocumentPlaceholder startDocumentSelection={startDocumentSelection} />
        )}
      </div>
    )}
  </LinkToDocumentContainer>
);

LinkToDocumentField.displayName = 'LinkToDocumentField';

LinkToDocumentField.propTypes = {
  container: PropTypes.object.isRequired,
  status: PropTypes.string.isRequired,
  document: PropTypes.object,
  onSelectDocumentPushpin: PropTypes.func.isRequired,
  onRemoveDocument: PropTypes.func.isRequired
};

export default LinkToDocumentField;
